{
  "version": "0.1.38",
  "colors": {
    "brand": [
      {
        "name": "gray",
        "description": "Neutral gray scale",
        "shades": {
          "50": "#f9fafb",
          "100": "#f3f4f6",
          "200": "#e5e7eb",
          "300": "#d1d5db",
          "400": "#9ca3af",
          "500": "#7a7a7a",
          "600": "#4f4f4f",
          "700": "#3d3d3d",
          "800": "#2a2a2a",
          "900": "#1a1a1a",
          "950": "#0a0a0a"
        },
        "note": "Unlike other palettes, gray does not include a foreground property as it is used for text colors, not as a background"
      },
      {
        "name": "red",
        "description": "Brand red for logo and accents",
        "shades": {
          "50": "#fef2f2",
          "100": "#fee2e2",
          "200": "#fecaca",
          "300": "#fca5a5",
          "400": "#f87171",
          "500": "#e02726",
          "600": "#c81f1e",
          "700": "#a91c22",
          "800": "#7f1d1d",
          "900": "#5c1010",
          "950": "#3d0a0a"
        },
        "foreground": "#ffffff"
      },
      {
        "name": "teal",
        "description": "Core 1 - Primary brand accent",
        "shades": {
          "50": "#f0fafa",
          "100": "#d9f2f3",
          "200": "#b3e6e7",
          "300": "#8dd9db",
          "400": "#67cccf",
          "500": "#3ba4a7",
          "600": "#2f8386",
          "700": "#236265",
          "800": "#184144",
          "900": "#0c2123",
          "950": "#061012"
        },
        "foreground": "#ffffff"
      },
      {
        "name": "navy",
        "description": "Core 2 - Professional dark blue",
        "shades": {
          "50": "#f0f4f6",
          "100": "#d9e4ea",
          "200": "#b3c9d5",
          "300": "#8daebf",
          "400": "#6793aa",
          "500": "#417895",
          "600": "#2d5467",
          "700": "#002e3f",
          "800": "#00242f",
          "900": "#001a20",
          "950": "#000d10"
        },
        "foreground": "#ffffff"
      },
      {
        "name": "plum",
        "description": "Core 3 - Rich burgundy/purple",
        "shades": {
          "50": "#f8f4f6",
          "100": "#ede2e8",
          "200": "#dbc5d1",
          "300": "#c9a8ba",
          "400": "#b78ba3",
          "500": "#a56e8c",
          "600": "#7f4968",
          "700": "#5e2c41",
          "800": "#4b2334",
          "900": "#381a27",
          "950": "#1c0d13"
        },
        "foreground": "#ffffff"
      },
      {
        "name": "sage",
        "description": "Core 4 - Muted green/gray",
        "shades": {
          "50": "#f7f7f5",
          "100": "#eaebe6",
          "200": "#dddfd5",
          "300": "#d0d3c5",
          "400": "#c3c7b5",
          "500": "#b6baa4",
          "600": "#969a82",
          "700": "#757968",
          "800": "#54574e",
          "900": "#333634",
          "950": "#1a1b1a"
        },
        "note": "Unlike other palettes, sage does not include a foreground property as it is used primarily for subtle backgrounds"
      },
      {
        "name": "stone",
        "description": "Collection - Stone gray",
        "shades": {
          "50": "#f7f7f7",
          "100": "#ebebeb",
          "200": "#d7d8d7",
          "300": "#c3c5c3",
          "400": "#afb2af",
          "500": "#9b9f9b",
          "600": "#878c87",
          "700": "#676d69",
          "800": "#4d524f",
          "900": "#333735",
          "950": "#1a1b1b"
        },
        "foreground": "#ffffff"
      },
      {
        "name": "forest",
        "description": "Collection - Forest green",
        "shades": {
          "50": "#f4f7f5",
          "100": "#e1ebe4",
          "200": "#c3d7c9",
          "300": "#a5c3ae",
          "400": "#87af93",
          "500": "#6aa275",
          "600": "#55825d",
          "700": "#406146",
          "800": "#2b412e",
          "900": "#162017",
          "950": "#0b100c"
        },
        "foreground": "#ffffff"
      },
      {
        "name": "lavender",
        "description": "Collection - Lavender purple",
        "shades": {
          "50": "#f7f6f8",
          "100": "#ece9ed",
          "200": "#d9d3db",
          "300": "#c6bdc9",
          "400": "#b3a7b7",
          "500": "#a091a5",
          "600": "#8d7b93",
          "700": "#695a75",
          "800": "#51445a",
          "900": "#392e3f",
          "950": "#1d1720"
        },
        "foreground": "#ffffff"
      },
      {
        "name": "sky",
        "description": "Collection - Sky blue",
        "shades": {
          "50": "#f4f8fb",
          "100": "#e2ecf3",
          "200": "#c5d9e7",
          "300": "#a8c6db",
          "400": "#8bb3cf",
          "500": "#6ea0c3",
          "600": "#5f91b8",
          "700": "#4c7493",
          "800": "#39576e",
          "900": "#263a49",
          "950": "#131d25"
        },
        "foreground": "#ffffff"
      },
      {
        "name": "deepTeal",
        "description": "Collection - Deep teal",
        "shades": {
          "50": "#f2f5f5",
          "100": "#dce5e4",
          "200": "#b9cbc9",
          "300": "#96b1ae",
          "400": "#739793",
          "500": "#507d78",
          "600": "#306966",
          "700": "#244e4b",
          "800": "#18332f",
          "900": "#0c1918",
          "950": "#060c0c"
        },
        "foreground": "#ffffff"
      },
      {
        "name": "charcoal",
        "description": "Collection - Charcoal gray",
        "shades": {
          "50": "#fafafa",
          "100": "#e6e6e6",
          "200": "#cccccc",
          "300": "#b3b3b3",
          "400": "#999999",
          "500": "#808080",
          "600": "#666666",
          "700": "#4d4d4d",
          "800": "#333333",
          "900": "#292424",
          "950": "#141212"
        },
        "foreground": "#ffffff"
      }
    ],
    "semantic": {
      "background": {
        "light": "white (#ffffff)",
        "dark": "charcoal-900 (#292424)",
        "hover": {
          "light": "#fafafa",
          "dark": "#333333"
        }
      },
      "foreground": {
        "light": "gray-600 (#4f4f4f)",
        "dark": "gray-100 (#f3f4f6)"
      },
      "primary": {
        "light": "red-700 (#a91c22)",
        "dark": "red-400 (#f87171)",
        "hover": {
          "light": "#8a171c",
          "dark": "#f9a8a8"
        },
        "foreground": "#ffffff"
      },
      "secondary": {
        "light": "sage-100 (#eaebe6)",
        "dark": "sage-800 (#54574e)",
        "hover": {
          "light": "#d4d6cc",
          "dark": "#5c6156"
        },
        "foreground": {
          "light": "gray-600 (#4f4f4f)",
          "dark": "gray-100 (#f3f4f6)"
        }
      },
      "accent": {
        "light": "teal-500 (#3ba4a7)",
        "dark": "teal-400 (#67cccf)",
        "hover": {
          "light": "#319295",
          "dark": "#8fd9dc"
        },
        "foreground": "#ffffff"
      },
      "muted": {
        "light": "sage-100 (#eaebe6)",
        "dark": "charcoal-700 (#4d4d4d)",
        "hover": {
          "light": "#d4d6cc",
          "dark": "#5c5c5c"
        },
        "foreground": {
          "light": "gray-500 (#7a7a7a)",
          "dark": "gray-400 (#9ca3af)"
        }
      },
      "destructive": {
        "light": "red-500 (#e02726)",
        "dark": "red-500 (#e02726)",
        "hover": {
          "light": "#d92626",
          "dark": "#f87171"
        },
        "foreground": "#ffffff"
      },
      "card": {
        "light": "#ffffff",
        "dark": "charcoal-800 (#333333)",
        "foreground": {
          "light": "gray-600 (#4f4f4f)",
          "dark": "gray-100 (#f3f4f6)"
        }
      },
      "popover": {
        "light": "#ffffff",
        "dark": "charcoal-800 (#333333)",
        "foreground": {
          "light": "gray-600 (#4f4f4f)",
          "dark": "gray-100 (#f3f4f6)"
        }
      },
      "border": {
        "light": "#000000",
        "dark": "gray-400 (#9ca3af)",
        "note": "CAD/drafter aesthetic - hard black borders in light mode"
      },
      "input": {
        "light": "#000000",
        "dark": "gray-400 (#9ca3af)"
      },
      "ring": {
        "light": "red-700 (#a91c22)",
        "dark": "red-400 (#f87171)"
      },
      "success": {
        "light": "#10b981",
        "dark": "#34d399",
        "foreground": {
          "light": "#ffffff",
          "dark": "charcoal-900"
        }
      },
      "warning": {
        "light": "#f59e0b",
        "dark": "#fbbf24",
        "foreground": {
          "light": "#ffffff",
          "dark": "charcoal-900"
        }
      },
      "info": {
        "light": "#3b82f6",
        "dark": "#60a5fa",
        "foreground": {
          "light": "#ffffff",
          "dark": "charcoal-900"
        }
      }
    },
    "layout": {
      "contentBg": {
        "light": "#fafafa",
        "dark": "charcoal-800 (#333333)",
        "note": "Main content background (slightly darker grey)"
      },
      "surfaceBorder": {
        "light": "#000000",
        "dark": "gray-400 (#9ca3af)",
        "note": "CAD/drafter aesthetic"
      }
    },
    "status": {
      "success": "#10b981",
      "warning": "#f59e0b",
      "error": "#ef4444",
      "info": "#3b82f6",
      "note": "Standard status colors for alerts, notifications, and feedback"
    }
  },
  "spacing": [
    {
      "key": "0",
      "value": "0",
      "pixels": "0"
    },
    {
      "key": "px",
      "value": "1px",
      "pixels": "1px"
    },
    {
      "key": "0.5",
      "value": "0.125rem",
      "pixels": "2px"
    },
    {
      "key": "1",
      "value": "0.25rem",
      "pixels": "4px"
    },
    {
      "key": "1.5",
      "value": "0.375rem",
      "pixels": "6px"
    },
    {
      "key": "2",
      "value": "0.5rem",
      "pixels": "8px"
    },
    {
      "key": "2.5",
      "value": "0.625rem",
      "pixels": "10px"
    },
    {
      "key": "3",
      "value": "0.75rem",
      "pixels": "12px"
    },
    {
      "key": "3.5",
      "value": "0.875rem",
      "pixels": "14px"
    },
    {
      "key": "4",
      "value": "1rem",
      "pixels": "16px"
    },
    {
      "key": "5",
      "value": "1.25rem",
      "pixels": "20px"
    },
    {
      "key": "6",
      "value": "1.5rem",
      "pixels": "24px"
    },
    {
      "key": "7",
      "value": "1.75rem",
      "pixels": "28px"
    },
    {
      "key": "8",
      "value": "2rem",
      "pixels": "32px"
    },
    {
      "key": "9",
      "value": "2.25rem",
      "pixels": "36px"
    },
    {
      "key": "10",
      "value": "2.5rem",
      "pixels": "40px"
    },
    {
      "key": "11",
      "value": "2.75rem",
      "pixels": "44px"
    },
    {
      "key": "12",
      "value": "3rem",
      "pixels": "48px"
    },
    {
      "key": "14",
      "value": "3.5rem",
      "pixels": "56px"
    },
    {
      "key": "16",
      "value": "4rem",
      "pixels": "64px"
    },
    {
      "key": "20",
      "value": "5rem",
      "pixels": "80px"
    },
    {
      "key": "24",
      "value": "6rem",
      "pixels": "96px"
    },
    {
      "key": "28",
      "value": "7rem",
      "pixels": "112px"
    },
    {
      "key": "32",
      "value": "8rem",
      "pixels": "128px"
    },
    {
      "key": "36",
      "value": "9rem",
      "pixels": "144px"
    },
    {
      "key": "40",
      "value": "10rem",
      "pixels": "160px"
    },
    {
      "key": "44",
      "value": "11rem",
      "pixels": "176px"
    },
    {
      "key": "48",
      "value": "12rem",
      "pixels": "192px"
    },
    {
      "key": "52",
      "value": "13rem",
      "pixels": "208px"
    },
    {
      "key": "56",
      "value": "14rem",
      "pixels": "224px"
    },
    {
      "key": "60",
      "value": "15rem",
      "pixels": "240px"
    },
    {
      "key": "64",
      "value": "16rem",
      "pixels": "256px"
    },
    {
      "key": "72",
      "value": "18rem",
      "pixels": "288px"
    },
    {
      "key": "80",
      "value": "20rem",
      "pixels": "320px"
    },
    {
      "key": "96",
      "value": "24rem",
      "pixels": "384px"
    }
  ],
  "typography": {
    "fontFamilies": {
      "sans": "Figtree, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, sans-serif",
      "serif": "Source Serif Variable, Source Serif Pro, ui-serif, Georgia, Cambria, Times New Roman, Times, serif",
      "mono": "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, Liberation Mono, Courier New, monospace"
    },
    "fontSizes": {
      "xs": {
        "size": "0.75rem",
        "lineHeight": "1rem",
        "pixels": "12px"
      },
      "sm": {
        "size": "0.875rem",
        "lineHeight": "1.25rem",
        "pixels": "14px"
      },
      "base": {
        "size": "1rem",
        "lineHeight": "1.5rem",
        "pixels": "16px"
      },
      "lg": {
        "size": "1.125rem",
        "lineHeight": "1.75rem",
        "pixels": "18px"
      },
      "xl": {
        "size": "1.25rem",
        "lineHeight": "1.75rem",
        "pixels": "20px"
      },
      "2xl": {
        "size": "1.5rem",
        "lineHeight": "2rem",
        "pixels": "24px"
      },
      "3xl": {
        "size": "1.875rem",
        "lineHeight": "2.25rem",
        "pixels": "30px"
      },
      "4xl": {
        "size": "2.25rem",
        "lineHeight": "2.5rem",
        "pixels": "36px"
      },
      "5xl": {
        "size": "3rem",
        "lineHeight": "1",
        "pixels": "48px"
      },
      "6xl": {
        "size": "3.75rem",
        "lineHeight": "1",
        "pixels": "60px"
      },
      "7xl": {
        "size": "4.5rem",
        "lineHeight": "1",
        "pixels": "72px"
      },
      "8xl": {
        "size": "6rem",
        "lineHeight": "1",
        "pixels": "96px"
      },
      "9xl": {
        "size": "8rem",
        "lineHeight": "1",
        "pixels": "128px"
      }
    },
    "headingSizes": {
      "h1": {
        "size": "2.25rem",
        "lineHeight": "2.5rem",
        "fontWeight": "600",
        "pixels": "36px"
      },
      "h2": {
        "size": "1.875rem",
        "lineHeight": "2.25rem",
        "fontWeight": "600",
        "pixels": "30px"
      },
      "h3": {
        "size": "1.5rem",
        "lineHeight": "2rem",
        "fontWeight": "600",
        "pixels": "24px"
      },
      "h4": {
        "size": "1.25rem",
        "lineHeight": "1.75rem",
        "fontWeight": "600",
        "pixels": "20px"
      },
      "h5": {
        "size": "1.125rem",
        "lineHeight": "1.75rem",
        "fontWeight": "600",
        "pixels": "18px"
      },
      "h6": {
        "size": "1rem",
        "lineHeight": "1.5rem",
        "fontWeight": "600",
        "pixels": "16px"
      }
    },
    "fontWeights": {
      "thin": 100,
      "extralight": 200,
      "light": 300,
      "normal": 400,
      "medium": 500,
      "semibold": 600,
      "bold": 700,
      "extrabold": 800,
      "black": 900
    }
  },
  "borderRadius": {
    "none": "0",
    "sm": "0.125rem",
    "DEFAULT": "0.5rem",
    "md": "0.5rem",
    "lg": "0.75rem",
    "xl": "1rem",
    "2xl": "1.5rem",
    "3xl": "2rem",
    "full": "9999px"
  },
  "boxShadow": {
    "sm": "0 1px 2px 0 rgb(0 0 0 / 0.05)",
    "DEFAULT": "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
    "md": "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
    "lg": "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
    "xl": "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
    "2xl": "0 25px 50px -12px rgb(0 0 0 / 0.25)",
    "inner": "inset 0 2px 4px 0 rgb(0 0 0 / 0.05)",
    "none": "none"
  },
  "zIndex": {
    "0": "0",
    "10": "10",
    "20": "20",
    "30": "30",
    "40": "40",
    "50": "50",
    "auto": "auto"
  },
  "breakpoints": {
    "sm": "640px",
    "md": "768px",
    "lg": "1024px",
    "xl": "1280px",
    "2xl": "1536px"
  },
  "transition": {
    "duration": {
      "fast": "150ms",
      "base": "200ms",
      "slow": "300ms",
      "slower": "500ms"
    },
    "timing": {
      "ease": "ease",
      "easeIn": "ease-in",
      "easeOut": "ease-out",
      "easeInOut": "ease-in-out",
      "linear": "linear"
    }
  },
  "animations": {
    "accordion-down": "accordion-down 0.2s ease-out",
    "accordion-up": "accordion-up 0.2s ease-out",
    "collapsible-down": "collapsible-down 0.2s ease-out",
    "collapsible-up": "collapsible-up 0.2s ease-out",
    "fade-in": "fade-in 0.2s ease-out",
    "fade-out": "fade-out 0.2s ease-out",
    "slide-up": "slide-up 0.2s ease-out",
    "slide-down": "slide-down 0.2s ease-out",
    "slide-left": "slide-left 0.2s ease-out",
    "slide-right": "slide-right 0.2s ease-out",
    "scale-in": "scale-in 0.2s ease-out",
    "scale-out": "scale-out 0.2s ease-out",
    "spin-slow": "spin-slow 2s linear infinite",
    "pulse-subtle": "pulse-subtle 2s cubic-bezier(0.4, 0, 0.6, 1) infinite"
  },
  "keyframes": {
    "accordion-down": {
      "from": "height: 0",
      "to": "height: var(--radix-accordion-content-height)"
    },
    "accordion-up": {
      "from": "height: var(--radix-accordion-content-height)",
      "to": "height: 0"
    },
    "collapsible-down": {
      "from": "height: 0",
      "to": "height: var(--bits-collapsible-content-height)"
    },
    "collapsible-up": {
      "from": "height: var(--bits-collapsible-content-height)",
      "to": "height: 0"
    },
    "fade-in": {
      "from": "opacity: 0",
      "to": "opacity: 1"
    },
    "fade-out": {
      "from": "opacity: 1",
      "to": "opacity: 0"
    },
    "slide-up": {
      "from": "opacity: 0, translateY(10px)",
      "to": "opacity: 1, translateY(0)"
    },
    "slide-down": {
      "from": "opacity: 0, translateY(-10px)",
      "to": "opacity: 1, translateY(0)"
    },
    "slide-left": {
      "from": "opacity: 0, translateX(10px)",
      "to": "opacity: 1, translateX(0)"
    },
    "slide-right": {
      "from": "opacity: 0, translateX(-10px)",
      "to": "opacity: 1, translateX(0)"
    },
    "scale-in": {
      "from": "opacity: 0, scale(0.95)",
      "to": "opacity: 1, scale(1)"
    },
    "scale-out": {
      "from": "opacity: 1, scale(1)",
      "to": "opacity: 0, scale(0.95)"
    },
    "spin-slow": {
      "from": "rotate(0deg)",
      "to": "rotate(360deg)"
    },
    "pulse-subtle": {
      "0%, 100%": "opacity: 1",
      "50%": "opacity: 0.7"
    }
  },
  "tailwindPreset": {
    "description": "The @classic-homes/theme-tailwind-preset extends base tokens with CSS variable-based theming",
    "container": {
      "center": true,
      "padding": {
        "DEFAULT": "1rem",
        "sm": "2rem",
        "lg": "4rem",
        "xl": "5rem",
        "2xl": "6rem"
      },
      "screens": {
        "sm": "640px",
        "md": "768px",
        "lg": "1024px",
        "xl": "1280px",
        "2xl": "1400px"
      },
      "note": "Container uses 1400px for 2xl (narrower than default 1536px) for better readability"
    },
    "borderRadiusOverrides": {
      "lg": "var(--radius)",
      "md": "calc(var(--radius) - 2px)",
      "sm": "calc(var(--radius) - 4px)",
      "note": "These override token values to use CSS variable for runtime theming"
    },
    "semanticColorUtilities": {
      "description": "Semantic colors use CSS variables in HSL format for Tailwind theming support",
      "pattern": "hsl(var(--{name})) e.g., hsl(var(--primary))",
      "availableColors": [
        "border",
        "input",
        "ring",
        "background",
        "foreground",
        "primary",
        "secondary",
        "destructive",
        "muted",
        "accent",
        "popover",
        "card",
        "success",
        "warning",
        "info",
        "content-bg",
        "surface-border"
      ],
      "colorVariants": {
        "withForeground": [
          "primary",
          "secondary",
          "destructive",
          "muted",
          "accent",
          "popover",
          "card",
          "success",
          "warning",
          "info"
        ],
        "withHover": [
          "background",
          "primary",
          "secondary",
          "destructive",
          "muted",
          "accent"
        ]
      }
    },
    "sidebarColors": {
      "description": "Sidebar-specific color utilities for navigation styling",
      "utilities": [
        "sidebar (background)",
        "sidebar-foreground",
        "sidebar-primary",
        "sidebar-primary-foreground",
        "sidebar-accent",
        "sidebar-accent-foreground",
        "sidebar-accent-hover",
        "sidebar-border",
        "sidebar-ring"
      ]
    },
    "chartColors": {
      "description": "Chart color palette for data visualization",
      "utilities": [
        "chart-1",
        "chart-2",
        "chart-3",
        "chart-4",
        "chart-5"
      ],
      "note": "Uses brand colors: teal, navy, plum, forest, sky"
    },
    "brandUtilities": {
      "description": "Direct brand color access via CSS variables (hex values)",
      "utilities": [
        "brand-red-logo",
        "brand-red-primary",
        "brand-grey-1",
        "brand-grey-2",
        "brand-core-1",
        "brand-core-2",
        "brand-core-3",
        "brand-core-4",
        "brand-core-4-tint",
        "brand-collection-1",
        "brand-collection-2",
        "brand-collection-3",
        "brand-collection-4",
        "brand-collection-5",
        "brand-collection-6"
      ],
      "pattern": "var(--color-{name}) e.g., var(--color-red-logo)"
    }
  }
}